import React from 'react';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import buttonStyles from 'ui-components/components/button/button-text.module.less';

import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';

import style from '../../onboard-cards.module.less';
import { messages } from '../../messages';
import { FormattedMessage } from 'react-intl';

export const DismissGuideButton = () => {
  const { dismissOnboarding } = useHomePageOnboardContext();
  return (
    <Button
      className={classnames(style['link-button'], style['footer-row-group'], buttonStyles['button-text'])}
      onClick={dismissOnboarding}
      theme='link'
    >
      <FormattedMessage {...messages.dismissGuideButton} />
    </Button>
  );
};
